import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../../redux/services/Imports';
import './StoryIcon.scss';
import './StoryIcon-media.scss';
import { Props } from './interfaces';

import { EnumUrlsPages } from '../../../services/Enum';
import {Link} from "../../Link/Link";

const StoryIcon = ({ image, name, i }: Props) => {
  return (
    <Link to={`${EnumUrlsPages.story}?s=${i + 1}`} className="story">
      <div style={{ backgroundImage: `url(${image})` }} className="story__image" />
      <p className="story__name">{name}</p>
    </Link>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(StoryIcon));
